// Boltline shared front-end behaviour — plain vanilla JS (no jQuery).
// In-page smooth scroll, FAQ accordion, scroll reveal, and the page fade-in.
// Self-guards against double-init because Shopify reloads sections in the editor.
(function () {
	if (window.__boltlineCommonInit) { return; }
	window.__boltlineCommonInit = true;

	// --- helpers ---------------------------------------------------------------
	function ready(fn) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', fn);
		} else {
			fn();
		}
	}

	function onLoad(fn) {
		if (document.readyState === 'complete') {
			fn();
		} else {
			window.addEventListener('load', fn);
		}
	}

	function prefersReducedMotion() {
		return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
	}

	// Find the anchor target by id, falling back to a [name="…"] element.
	function resolveTarget(hash) {
		var id = (hash || '').slice(1);
		if (!id) { return null; }
		return document.getElementById(id) || document.querySelector('[name="' + id + '"]');
	}

	function headerHeight() {
		// The Boltline header section was replaced by the store header-group on
		// 2026-09-10. .header_content is kept as a fallback in case the section is
		// ever re-added; lp-chrome-offset.js measures the sticky store header.
		var header = document.querySelector('.header_content');
		if (header) { return header.offsetHeight; }
		return typeof window.LPStickyChromeOffset === 'function' ? window.LPStickyChromeOffset() : 0;
	}

	// Animated scroll to an absolute Y, matching the reference's jQuery
	// animate(1000ms, swing). Jumps instantly when reduced motion is preferred.
	function scrollToY(targetY, duration) {
		if (prefersReducedMotion() || !window.requestAnimationFrame) {
			window.scrollTo(0, targetY);
			return;
		}
		var startY = window.pageYOffset;
		var diff = targetY - startY;
		if (diff === 0) { return; }
		var startTime = null;
		function step(now) {
			if (startTime === null) { startTime = now; }
			var elapsed = now - startTime;
			var p = Math.min(elapsed / duration, 1);
			var eased = 0.5 - Math.cos(p * Math.PI) / 2; // jQuery "swing" easing
			window.scrollTo(0, Math.round(startY + diff * eased));
			if (elapsed < duration) { window.requestAnimationFrame(step); }
		}
		window.requestAnimationFrame(step);
	}

	// slideDown / slideUp / slideToggle — vanilla equivalents of jQuery's height
	// slide, preserving the accordion's show/hide animation.
	function slideDown(el, duration) {
		el.style.removeProperty('display');
		var display = window.getComputedStyle(el).display;
		if (display === 'none') { display = 'block'; }
		el.style.display = display;
		var height = el.offsetHeight;
		el.style.overflow = 'hidden';
		el.style.height = '0px';
		el.style.paddingTop = '0px';
		el.style.paddingBottom = '0px';
		el.style.marginTop = '0px';
		el.style.marginBottom = '0px';
		el.offsetHeight; // force reflow so the transition starts from 0
		el.style.boxSizing = 'border-box';
		el.style.transitionProperty = 'height, margin, padding';
		el.style.transitionDuration = duration + 'ms';
		el.style.height = height + 'px';
		el.style.removeProperty('padding-top');
		el.style.removeProperty('padding-bottom');
		el.style.removeProperty('margin-top');
		el.style.removeProperty('margin-bottom');
		window.setTimeout(function () {
			el.style.removeProperty('height');
			el.style.removeProperty('overflow');
			el.style.removeProperty('transition-duration');
			el.style.removeProperty('transition-property');
			el.style.removeProperty('box-sizing');
		}, duration);
	}

	function slideUp(el, duration) {
		el.style.boxSizing = 'border-box';
		el.style.height = el.offsetHeight + 'px';
		el.offsetHeight; // force reflow
		el.style.overflow = 'hidden';
		el.style.transitionProperty = 'height, margin, padding';
		el.style.transitionDuration = duration + 'ms';
		el.style.height = '0px';
		el.style.paddingTop = '0px';
		el.style.paddingBottom = '0px';
		el.style.marginTop = '0px';
		el.style.marginBottom = '0px';
		window.setTimeout(function () {
			el.style.display = 'none';
			el.style.removeProperty('height');
			el.style.removeProperty('padding-top');
			el.style.removeProperty('padding-bottom');
			el.style.removeProperty('margin-top');
			el.style.removeProperty('margin-bottom');
			el.style.removeProperty('overflow');
			el.style.removeProperty('transition-duration');
			el.style.removeProperty('transition-property');
			el.style.removeProperty('box-sizing');
		}, duration);
	}

	function slideToggle(el, duration) {
		var hidden = window.getComputedStyle(el).display === 'none' || el.offsetHeight === 0;
		if (hidden) { slideDown(el, duration); } else { slideUp(el, duration); }
	}

	// fadeIn — vanilla equivalent of jQuery fadeIn(). For an element that is
	// already visible (the .fade wrapper is revealed by CSS) this is effectively
	// a no-op, exactly as it was with jQuery.
	function fadeIn(el, duration) {
		var computed = window.getComputedStyle(el);
		var from;
		if (computed.display === 'none') {
			from = 0;
			el.style.display = '';
			if (window.getComputedStyle(el).display === 'none') { el.style.display = 'block'; }
		} else {
			from = parseFloat(computed.opacity);
			if (isNaN(from)) { from = 1; }
		}
		if (prefersReducedMotion() || !window.requestAnimationFrame || from >= 1) {
			el.style.removeProperty('opacity');
			return;
		}
		el.style.opacity = String(from);
		var startTime = null;
		function step(now) {
			if (startTime === null) { startTime = now; }
			var p = Math.min((now - startTime) / duration, 1);
			el.style.opacity = String(from + (1 - from) * p);
			if (p < 1) { window.requestAnimationFrame(step); }
			else { el.style.removeProperty('opacity'); }
		}
		window.requestAnimationFrame(step);
	}

	// --- behaviour -------------------------------------------------------------
	ready(function () {
		// In-page links (same page): smooth-scroll to the target, offset by header.
		var anchors = document.querySelectorAll('a[href*="#"]:not([href="#"])');
		Array.prototype.forEach.call(anchors, function (link) {
			link.addEventListener('click', function (e) {
				if (location.pathname.replace(/^\//, '') === link.pathname.replace(/^\//, '') &&
					location.hostname === link.hostname) {
					var target = resolveTarget(link.hash);
					if (target) {
						var targetOffset = target.getBoundingClientRect().top + window.pageYOffset - headerHeight();
						scrollToY(targetOffset, 1000);
						e.preventDefault();
						e.stopPropagation();
					}
				}
			});
		});

		// In-page links (arriving from another page): reset to top, then scroll
		// to the hash target on the next tick.
		var hash = location.hash;
		if (hash) {
			window.scrollTo(0, 0);
			window.setTimeout(function () {
				var target = resolveTarget(hash);
				if (!target) { return; }
				var targetOffset = target.getBoundingClientRect().top + window.pageYOffset - headerHeight();
				scrollToY(targetOffset, 1000);
			}, 0);
		}

		// Accordion (FAQ): toggle the answer box + the .close/aria-expanded state
		// on its <button class="title">. Each item toggles independently.
		var titles = document.querySelectorAll('.title');
		Array.prototype.forEach.call(titles, function (title) {
			title.addEventListener('click', function () {
				var box = title.nextElementSibling;
				if (box && box.classList.contains('box')) {
					slideToggle(box, 400);
				}
				if (title.classList.contains('close')) {
					title.classList.remove('close');
					title.setAttribute('aria-expanded', 'false');
				} else {
					title.classList.add('close');
					title.setAttribute('aria-expanded', 'true');
				}
			});
		});

		// Scroll fade-in.
		// Reveal on scroll via IntersectionObserver (unobserve after reveal) instead of
		// measuring every element on every scroll event. rootMargin '-100px' at the
		// bottom reproduces the reference's "> boxOffset - wh + 100" trigger point, so
		// the reveal timing stays visually identical.
		var boxes = document.querySelectorAll('.fadeInup');
		if (boxes.length) {
			if ('IntersectionObserver' in window) {
				var io = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							entry.target.classList.add('active');
							observer.unobserve(entry.target);
						}
					});
				}, { rootMargin: '0px 0px -100px 0px' });
				Array.prototype.forEach.call(boxes, function (box) { io.observe(box); });
			} else {
				Array.prototype.forEach.call(boxes, function (box) { box.classList.add('active'); });
			}
		}
	});

	// Site fade-in on window load (matches the reference fadeIn(1500)).
	onLoad(function () {
		var fades = document.querySelectorAll('.fade');
		Array.prototype.forEach.call(fades, function (el) { fadeIn(el, 1500); });
	});
})();
